// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7ae03a4f","936":"b248d280"}[chunkId] + ".chunk.js";
};